"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var AppSpinner_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/app-spinner/AppSpinner"));
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var constants_1 = __importDefault(require("../../../config/constants"));
var actions_1 = require("../../../redux/reducers/preferences/actions");
var Preference_1 = __importDefault(require("./components/Preference"));
var styles_2 = __importDefault(require("./styles"));
var ALL = '__ALL__';
var PreferencesScreen = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_1.fetchMyPreferences)())];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_1.loadMyPreferences)())];
                case 2:
                    _a.sent();
                    return [4, dispatch((0, actions_1.fetchOptions)())];
                case 3:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        document.title = 'Preferences';
        getData();
    }, []);
    var preferences = (0, react_redux_1.useSelector)(function (state) { return state.preferences.tempState || {}; });
    var onTogglePreference = function (name) {
        if (name === ALL) {
            dispatch((0, actions_1.toggleAllPreference)());
        }
        else {
            dispatch((0, actions_1.togglePreference)(name));
        }
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, dispatch((0, actions_1.savePreferences)())];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handlePreferenceDropdownChange = function (subCategory, value) {
        if (subCategory.options) {
            var option_1 = subCategory.options.find(function (opt) { return opt.id === value; });
            subCategory.value = option_1;
            var categoriesWithSubCategories = preferences === null || preferences === void 0 ? void 0 : preferences.categories.filter(function (c) {
                if (!lodash_1.default.isEmpty(c.subCategories)) {
                    return c;
                }
            });
            var subCategories = categoriesWithSubCategories === null || categoriesWithSubCategories === void 0 ? void 0 : categoriesWithSubCategories.map(function (c) {
                return c.subCategories;
            });
            var subCategoryToUpdate = lodash_1.default.flatten(subCategories).filter(function (sub) {
                return sub.MessageCategoryId === (option_1 === null || option_1 === void 0 ? void 0 : option_1.messageCategoryId);
            });
            if ((subCategoryToUpdate === null || subCategoryToUpdate === void 0 ? void 0 : subCategoryToUpdate.length) === 1) {
                subCategoryToUpdate[0].value = __assign(__assign({}, subCategoryToUpdate[0].value), option_1);
                dispatch((0, actions_1.updateSubCategory)(subCategoryToUpdate[0]));
            }
        }
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 3, lg: constants_1.default.ACCESSIBLE_PREFERENCE_SWITCH ? 12 : undefined, direction: "column" },
        (preferences === null || preferences === void 0 ? void 0 : preferences.fetching) && (react_1.default.createElement(AppSpinner_1.default, { label: 'Loading...', customStyles: {
                backgroundColor: 'transparent'
            } })),
        react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center", className: classes.header },
            react_1.default.createElement(Typography_1.default, { variant: "body2", className: classes.headerText }, "Choose when you want to receive emails from us.")),
        react_1.default.createElement("div", { className: classes.contentWrap },
            react_1.default.createElement(Preference_1.default, { item: {
                    key: ALL,
                    booleanValue: (preferences === null || preferences === void 0 ? void 0 : preferences.all) || false,
                    label: 'Send me all email communications',
                    subCategories: preferences === null || preferences === void 0 ? void 0 : preferences.categories,
                    options: preferences === null || preferences === void 0 ? void 0 : preferences.options
                }, onToggle: onTogglePreference, handlePreferenceDropdownChange: handlePreferenceDropdownChange, theme: theme })),
        react_1.default.createElement(Grid_1.default, { item: true, className: classes.buttonWrap },
            react_1.default.createElement(Button_1.default, { size: "large", variant: "contained", color: "primary", className: classes.button, onClick: onSave, "aria-label": "Save" }, "Save"))));
};
exports.default = PreferencesScreen;
//# sourceMappingURL=index.js.map